import { useState, useCallback } from 'react';
import { X } from 'lucide-react';
import { Input } from "@/Components/ui/input";
import { Button } from "@/Components/ui/button";
import PropTypes from 'prop-types';

const MenuModal = ({ isOpen, onClose, onSave }) => {
    const [name, setName] = useState('');
    const [nameError, setNameError] = useState('');

    const validateName = (value) => {
        if (!value || value.trim() === '') {
            return 'Naam is verplicht';
        }
        return '';
    };

    const handleChange = useCallback((e) => {
        const { name, value } = e.target;
        setName(value);
        setNameError(''); // Reset error on typing
    }, []);

    const handleSave = () => {
        const error = validateName(name);

        if (error) {
            setNameError(error);
            return;
        }

        onSave({
            id: 0,
            name: name
        });
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
            <div className="bg-white rounded-lg w-full max-w-md p-2 relative">
                <button
                    onClick={onClose}
                    className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
                >
                    <X size={24} />
                </button>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div className="md:col-span-6 space-y-6 p-8">
                        <div>
                            <label className="block text-sm font-inter text-ps-blue-dark mb-2">
                                Naam
                            </label>
                            <Input
                                type="text"
                                name="name"
                                value={name}
                                onChange={handleChange}
                                className={`w-full p-2 border rounded ${nameError ? 'border-red-500' : ''}`}
                                required
                            />
                            {nameError && (
                                <p className="text-red-500 text-sm mt-1">{nameError}</p>
                            )}
                        </div>
                    </div>
                </div>
                <div className="flex justify-end gap-4 pr-8 pb-4">
                    <Button
                        onClick={handleSave}
                        className="bg-ps-green w-40 hover:bg-ps-green/90 text-white font-inter"
                    >
                        Opslaan
                    </Button>
                </div>
            </div>
        </div>
    );
};

MenuModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
};

export default MenuModal;